<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_vii">ACKNOWLEDGMENTS</a></p><a id="page_vii">
<p class="imageb"><img alt="image" src="images/pgvii.jpg"/></p>
<p class="noindent"><span class="small">THE AUTHOR IS RESPONSIBLE FOR ALL ERRORS</span> of fact or interpretation. While he tended his manuscript, his wife Martha Ash and daughter Karolina Ash ably looked after him. This book would not have been possible without their support, and it is dedicated to them. The genesis of this work came from suggestions by Curtis Katz and Charles Stats. Greatly aiding the research and providing editorial criticism were Chris Baer of the Hagley Museum and Library, Greg Ames of the John W. Barriger III National Railroad Library, the late Ed DeRouin, the late Stanley Brandt, Roger Grant, Darrel Babek, Bob Johnson, Dave Leider, and Bill Shapotkin. Marc Magliori of Amtrak facilitated procurement of intellectual property. Dennis McClendon was an invaluable resource on Chicago history and an infallible proofreader, in addition to his cartographic expertise.</p>
<p class="indent">Chicago is blessed with tremendous research facilities and patient staff members at the Burnham Library of the Art Institute of Chicago, the Newberry Library, the Chicago History Museum, the Harold Washington branch of the Chicago Public Library, and the Northwestern University Transportation Center Library. Thank you to their staff. Gerald Austiff of the Metropolitan Water Reclamation District and architect Lucien LaGrange were unstinting with their time and assistance. Linda Oblack, Peggy Solic, Ashley Runyon, Rachel Rosolina, and Peter Froelich of Indiana University Press sagely advised on the nuances of the publications business. Brian Cudahy and John Spychalski provided suggestions and corrections critical to the manuscript. Jim Cappio’s diligence as copy editor is especially appreciated.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Acknowledgement.vue?64f37980